import * as PropTypes from "prop-types";
import React from "react";
import {Backdrop, CircularProgress, styled} from "@mui/material";

const WaitSpinnerElement = styled('div',{
  name:'WaitPanel',
  shouldForwardProp: (prop) =>
      prop !== 'colour' && prop !== 'variant' && prop !== 'sx',
  overridesResolver: (props, styles) => [
    styles[props.variant]
]
})({variant:'panel'});

type WaitSpinnerArgs = {
  variant: "panel"|"overlay"|"table"
};


export const WaitSpinner = function (props:WaitSpinnerArgs) {
  //const className =(props.type?'wait-panel-'+props.type:'')+(props.className?' '+props.className:'');
  if(props.variant=='table') {
    return <WaitSpinnerElement style={{gridColumn:"1/-1",height:"5rem",alignItems:"center",display:"flex",justifyContent:"center",backgroundColor:"#FFF"}}><CircularProgress/></WaitSpinnerElement>;
  }
  if(props.variant=='overlay') {
    // @ts-ignore
    return <Backdrop open={true} sx={{zIndex:1000}}>
      <WaitSpinnerElement variant="panel">
        <CircularProgress  sx={{color:(theme)=>theme.palette.primary.contrastText}}/>
      </WaitSpinnerElement>
    </Backdrop>
  }
  // @ts-ignore
  return (<WaitSpinnerElement variant="panel">
    <CircularProgress/>
  </WaitSpinnerElement>);
};

WaitSpinner.propTypes = {
  type:PropTypes.oneOf(['fixed','absolute'])
};

export default WaitSpinner;
